import { Location, Matrix } from "./types";

function getLocation<T>(matrix: Matrix<T>, location: Location): T {
  return matrix[location.row][location.col];
}

export default getLocation;
